import React, { useEffect, useRef } from 'react';
import { Hero } from '../components/Hero';
import { WhyDermaclinic } from '../components/WhyDermaclinic';
import { ServicesGrid } from '../components/ServicesGrid';
import { BeforeAfterGallery } from '../components/BeforeAfterGallery';
import { LeadForm } from '../components/LeadForm';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { initMetaPixel } from '../utils/metaPixel';
export function DermaclinicLanding() {
  const formRef = useRef<HTMLDivElement>(null);
  // Initialize Meta Pixel on mount
  useEffect(() => {
    initMetaPixel('1329531075115236');
  }, []);
  const scrollToForm = () => {
    formRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <main className="w-full min-h-screen" data-id="element-456">
      <Hero onCtaClick={scrollToForm} data-id="element-457" />
      <WhyDermaclinic data-id="element-458" />
      <ServicesGrid onCtaClick={scrollToForm} data-id="element-459" />
      <BeforeAfterGallery onCtaClick={scrollToForm} data-id="element-460" />
      <div ref={formRef} data-id="element-461">
        <LeadForm data-id="element-462" />
      </div>
      <FAQ data-id="element-463" />
      <FinalCTA onCtaClick={scrollToForm} data-id="element-464" />
    </main>;
}